import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Testimonials } from '../components/Testimonials';
import { CTABanner } from '../components/CTABanner';
import { ServiceArea } from '../components/ServiceArea';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-neutral-950 text-neutral-50 font-sans selection:bg-yellow-400 selection:text-neutral-950" data-id="element-219">
      <Navbar data-id="element-220" />
      <main data-id="element-221">
        <Hero data-id="element-222" />
        <Services data-id="element-223" />
        <WhyChooseUs data-id="element-224" />
        <Testimonials data-id="element-225" />
        <CTABanner data-id="element-226" />
        <ServiceArea data-id="element-227" />
      </main>
      <Footer data-id="element-228" />
    </div>;
}